// src/i18n/locales/ar/analytics.ts
export const arAnalyticsTranslations = {
  analytics: {
    // Main page
    title: "التحليلات",
    subtitle: "تتبع أداء مطعمك والحصول على رؤى قيمة",
    comingSoon: "قريباً",
    comingSoonDescription:
      "نحن نطور أدوات تحليلية قوية لمساعدتك في فهم أداء مطعمك وسلوك العملاء وفرص النمو.",

    // Action buttons
    notifyMe: "أخبرني عند الجاهزية",
    learnMore: "اعرف المزيد",
    tabs: {
      items: "العناصر",
      sales: "المبيعات",
      clients: "العملاء",
    },

    // Features section
    whatToExpected: "ما يمكن توقعه",
    soon: "قريباً",
    inDevelopment: "قيد التطوير",
    expectedLaunch: "الإطلاق المتوقع",

    // Feature descriptions
    features: {
      salesReports: "تقارير المبيعات",
      salesReportsDesc:
        "تقارير شاملة عن أداء المبيعات اليومية والأسبوعية والشهرية مع تفاصيل دقيقة.",

      customerInsights: "رؤى العملاء",
      customerInsightsDesc:
        "فهم سلوك العملاء وتفضيلاتهم وأنماط تناول الطعام لتحسين الخدمة.",

      performanceMetrics: "مقاييس الأداء",
      performanceMetricsDesc:
        "تتبع مؤشرات الأداء الرئيسية بما في ذلك نمو الإيرادات وتكرار الطلبات وساعات الذروة.",

      orderTracking: "تحليلات الطلبات",
      orderTrackingDesc:
        "مراقبة اتجاهات الطلبات ومتوسط قيمة الطلب وتحديد العناصر الأكثر مبيعاً.",

      menuViews: "تحليلات القائمة",
      menuViewsDesc:
        "اطلع على العناصر التي تحصل على أكبر عدد من المشاهدات والتفاعل من العملاء.",

      popularItems: "العناصر الشائعة",
      popularItemsDesc:
        "تحديد الأطباق الرائجة وتحسين قائمتك بناءً على تفضيلات العملاء.",
    },

    // Preview section
    previewTitle: "معاينة لوحة التحليلات",
    previewSubtitle:
      "احصل على لمحة عن الرؤى التي ستتمكن من الوصول إليها قريباً",
    chartPreview: "الرسوم البيانية والجداول التفاعلية قريباً",

    // Status messages
    dataLoading: "جاري تحميل بيانات التحليلات...",
    noDataAvailable: "لا توجد بيانات متاحة حتى الآن",

    // Time periods
    today: "اليوم",
    thisWeek: "هذا الأسبوع",
    thisMonth: "هذا الشهر",
    lastMonth: "الشهر الماضي",

    // Metrics
    totalRevenue: "إجمالي الإيرادات",
    totalOrders: "إجمالي الطلبات",
    totalSales: "إجمالي المبيعات",
    averageOrderValue: "متوسط قيمة الطلب",
    customerRetention: "الاحتفاظ بالعملاء",
    topSellingItems: "العناصر الأكثر مبيعاً",
    peakHours: "ساعات الذروة",
    sales: "المبيعات",
    branchIdNotFound: "لم يتم العثور على معرف الفرع",
    failedToFetchBranchStartDate: "فشل في جلب تاريخ بدء الفرع",
    errorFetchingBranchStartDate: "حدث خطأ أثناء جلب تاريخ بدء الفرع",
    contactViaWhatsApp: "تواصل عبر الواتساب",

    // New analytics dashboard keys
    totalClicks: "إجمالي النقرات",
    abrevHour: "س",
    avgTimeSpent: "متوسط الوقت المستغل",
    totalItems: "إجمالي العناصر",
    mostPopular: "الأكثر شهرة",
    noData: "لا توجد بيانات",
    monthlyTrends: "الاتجاهات الشهرية",
    itemPerformance: "أداء العناصر",
    itemDetails: "تفاصيل العناصر",
    clicks: "النقرات",
    timeSpent: "الوقت المستغل",
    avgTime: "متوسط الوقت",
    views: "المشاهدات",
    searchItems: "البحث في العناصر...",
    noItemsFound: "لم يتم العثور على عناصر",
    tryDifferentSearch: "جرب مصطلح بحث مختلف",
    priceNotSet: "السعر غير محدد",
    engagement: "التفاعل",
    allCategories: "جميع الفئات",
    allYears: "جميع السنوات",
    allMonths: "جميع الأشهر",
    timeFilters: "مرشحات الفترة الزمنية",
    selectYear: "اختر السنة",
    selectMonth: "اختر الشهر",
    showingAllData: "عرض البيانات لجميع الفترات الزمنية",
    showingDataFor: "عرض البيانات لـ",
    resetFilters: "إعادة تعيين المرشحات",
    branchSalesSummary: "ملخص مبيعات الفرع",
    updatedAutomatically: "يتم التحديث تلقائياً",
    period: "الفترة",
    latest: "الأخير",
    yearly: "سنوي",
    monthly: "شهري",
    daily: "يومي",

    // Sales Analytics Tab
    branchSalesOverview: "ملخص مبيعات الفرع",
    branchSalesDescription: "راقب أداء مبيعات فرعك الإجمالية",
    selectDateRange: "اختر نطاق التاريخ",
    dateRangeDescription: "اختر التواريخ لتحليل بيانات المبيعات الخاصة بك",
    quickOptions: "خيارات سريعة",
    customRange: "نطاق مخصص",
    dailySalesOrders: "نظرة عامة على المبيعات والطلبات اليومية",
    salesTrend: "اتجاه المبيعات",
    itemsBreakdown: "تفصيل العناصر",
    itemPerformanceComparison: "مقارنة أداء العناصر",
    itemPerformanceDescription: "قارن مقاييس الأداء عبر العناصر المحددة",
    performanceDateRange: "نطاق تاريخ الأداء",
    aiSales: "مبيعات الذكاء الاصطناعي",
    regularSales: "المبيعات العادية",
    avgOrderValue: "متوسط قيمة الطلب",
    orders: "طلبات",
    failedLoadSalesData: "فشل تحميل بيانات المبيعات. يرجى المحاولة مرة أخرى.",
    failedLoadPerformanceData: "فشل تحميل بيانات الأداء. يرجى المحاولة مرة أخرى.",

    // Clients Analytics Tab
    searchClients: "البحث بالاسم...",
    noClients: "لم يتم العثور على عملاء",
    clientName: "الاسم",
    clientPhone: "الهاتف",
    lastOrder: "آخر طلب",
    clientOrders: "الطلبات",
    clientTotalSpent: "إجمالي الإنفاق",
    clientAvgOrder: "متوسط الطلب",
    contact: "تواصل",

    // Date Picker & Presets
    from: "من",
    to: "إلى",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    last7Days: "آخر 7 أيام",
    last30Days: "آخر 30 يوم",
    yesterday: "أمس",

    // Items Analytics
    selectItemsToCompare: "اختر عناصر للمقارنة",
    selected: "محدد",
    maxItemsSelected:
      "تم تحديد الحد الأقصى {{maxItems}} من العناصر. قم بإزالة عنصر لإضافة المزيد.",
    searchItemsPlaceholder: "البحث عن العناصر بالاسم أو الفئة...",
    categories: "الفئات",
    sortedByClicks: "مصنف حسب النقرات",
    topPerformers: "الأفضل أداءً",
    noTopItems: "لم يتم العثور على عناصر مميزة للفترة المحددة",
    allItems: "جميع العناصر",
    noItems: "لم يتم العثور على عناصر للمرشحات المحددة",
    totalTimeSpent: "إجمالي الوقت المقضي",
    avgTimePerClick: "متوسط الوقت / نقرة",

    // Item Breakdown Table
    itemBreakdown: {
      title: "تفصيل العناصر",
      noData: "لا توجد بيانات عناصر متاحة",
      items: "عناصر",
      item: "العنصر",
      orders: "الطلبات",
      revenue: "الإيرادات",
      aiOrders: "طلبات الذكاء الاصطناعي",
      aiRevenue: "إيرادات الذكاء الاصطناعي",
      ofTotal: "من الإجمالي",
      ai: "ذكاء اصطناعي",
      unknown: "غير معروف",
    },

    // Item Performance Table
    itemPerformanceTable: {
      title: "ملخص أداء العناصر",
      selectItemsPrompt: "اختر العناصر أعلاه لعرض أدائها",
      rankedByRevenue: "مرتب حسب إجمالي الإيرادات",
      item: "العنصر",
      totalOrders: "إجمالي الطلبات",
      totalRevenue: "إجمالي الإيرادات",
      avgValue: "متوسط القيمة",
      orders: "الطلبات",
      revenue: "الإيرادات",
      avg: "متوسط",
      unknownCategory: "فئة غير معروفة",
    },

    // Performance Comparison Chart
    performanceComparison: {
      title: "مقارنة الأداء",
      selectItemsPrompt: "اختر العناصر لعرض مقارنة أدائها",
      monthlyRevenue: "مقارنة الإيرادات الشهرية",
      revenueTrends: "اتجاهات الإيرادات عبر العناصر المحددة",
      monthlyOrders: "مقارنة الطلبات الشهرية",
      orderTrends: "اتجاهات كمية الطلبات عبر العناصر المحددة",
      item: "العنصر",
    },

    // Chart
    noDataForPeriod: "لا توجد بيانات متاحة للفترة المحددة",

    // Months
    months: {
      january: "يناير",
      february: "فبراير",
      march: "مارس",
      april: "أبريل",
      may: "مايو",
      june: "يونيو",
      july: "يوليو",
      august: "أغسطس",
      september: "سبتمبر",
      october: "أكتوبر",
      november: "نوفمبر",
      december: "ديسمبر",
    },
  },
};
